import { AttributeTypes } from 'src/global-variables';

export interface FrontEndColumn {
  visibleInForSelection?: boolean;
  ignoreInAPI?: boolean;
  filterApplied?: boolean;
  filterable?: boolean;
  filterType?: FilterType;
  filterCode?: string;
  name: string;
  label?: string;
  sortable?: boolean;
  editable?: boolean;
  type?: string;
  dataType?: number;
  visible?: boolean;
  index?: number;
}

export enum FilterType {
  Number = 0,
  String,
  Date,
  Time,
  Text,
  Html,
  Select,
  MultiSelect,
  Object,
  Picture,
  Video,
  MediaGallery,
  Boolean,
}
export interface ModelField {
  Title: string;
  Code: string | number;
  DataType: AttributeTypes;
  Required?: boolean;
  IsRequired?: boolean;
  Scope: string;
  Object?: string;
  MaxLength?: number;
  AdditionalData?: any;
  Checked?: boolean;
  Visible?: boolean;
  VisibleOnScreen?: boolean;
}
